import { render, staticRenderFns } from "./ModalProcesarImagen.vue?vue&type=template&id=d6a50d74"
import script from "./ModalProcesarImagen.vue?vue&type=script&lang=js"
export * from "./ModalProcesarImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports